"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../shared/constants");
var lodash_1 = require("lodash");
var LP_REGION_CODES = [
    'US_CON',
];
var SUPPORTED_REGION_CODES = [
    'US_CON',
    'US_AK',
    'US_HI',
    'US_PR',
    'US_OTHER',
    'GB',
    'CA',
    'AU',
    'DE',
    'FR',
    'NL',
    'JP',
    'IT',
    'ES',
    'SE',
    'CH',
    'NZ',
    'BE',
    constants_1.default.EVERYWHERE_CODE,
];
var SUPPORTED_BUYING_GUIDE_REGION_CODES = [
    'US_CON',
    'US_AK',
    'US_HI',
    'US_PR',
    'US_OTHER',
    'CA',
];
function cspShippingRegionSupported(region) {
    return lodash_1.includes(SUPPORTED_REGION_CODES, region);
}
exports.cspShippingRegionSupported = cspShippingRegionSupported;
function lpEligibleRegion(region) {
    return lodash_1.includes(LP_REGION_CODES, region);
}
exports.lpEligibleRegion = lpEligibleRegion;
function learnContentEligibleRegion(locale) {
    return locale === 'en';
}
exports.learnContentEligibleRegion = learnContentEligibleRegion;
function buyingGuideEligibleRegionAndLocale(region, locale) {
    return lodash_1.includes(SUPPORTED_BUYING_GUIDE_REGION_CODES, region) && locale === 'en';
}
exports.buyingGuideEligibleRegionAndLocale = buyingGuideEligibleRegionAndLocale;
//# sourceMappingURL=user_helper.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/user_helper.js
// module id = TuLf
// module chunks = 20 21